import styled from '@emotion/styled';
import { spacing } from '$variables/theme';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: ${spacing.xxLarge};
`;
